import { gql } from '@apollo/client';

export const LIST_BRANDED_APP_PROMO_CODES_QUERY = gql`
    query ListBrandedAppPromoCodes {
        listBrandedAppPromoCodes {
            _id
            title
            code
            status
            endType
            endDate
            endAfterOccurrence
            setupDiscountMethod
            setupDiscountAmount
            subscriptionDiscountMethod
            subscriptionDiscountAmount
            subscriptionDiscountDuration
            createdAt
            usageCount
        }
    }
`;

export const GET_BRANDED_APP_PROMO_CODE_DETAIL_QUERY = gql`
    query GetBrandedAppPromoCodeDetails($input: BrandedAppPromoCodeIdDTO!) {
        getBrandedAppPromoCodeDetails(input: $input) {
            _id
            title
            code
            status
            endType
            endDate
            endAfterOccurrence
            setupDiscountMethod
            setupDiscountAmount
            subscriptionDiscountMethod
            subscriptionDiscountAmount
            subscriptionDiscountDuration
            createdAt
            usageCount
        }
    }
`;
